/**
 * Helper utility functions for the ExperienceSalesFooter component
 */

/**
 * Determines the button text based on the current flow and selection state
 */
export const getButtonText = (
  isExchangeFlow: boolean,
  hasSelection: boolean
): string => {
  if (isExchangeFlow) {
    return hasSelection ? "Confirm Exchange" : "Select Tickets";
  }
  return hasSelection ? "Buy Now" : "Select";
};

export const reservationStickyFooter = (organizationId?: string): boolean => {
  return organizationId !== "9c46120b-ba52-4fae-b6ac-1d93ba101ae2";
};
